import React from 'react';

const MyHistory = () => {
    return (
        <div>

        </div>
    );
};

export default MyHistory;